import { number } from "prop-types";
import React, { useState } from "react";

import VehicleQuantityInfoModal from "@components/VehicleQuantityInfo/VehicleQuantityInfoModal";
import Icon from "@components/shared/Icons/Icon";
import InfoIcon from "@components/shared/Icons/InfoIcon";

import { withTabNavigation } from "@hoc/withTabNavigation";

import { Trans } from "@lib/i18n";

const Link = withTabNavigation("a");

const VehicleQuantityInfo = ({ maximum }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLinkClick = event => {
    event.preventDefault();

    setIsModalOpen(true);
  };

  return (
    <>
      <div className="flex justify-between items-center gap-4 py-8 font-semibold">
        <Icon className="text-primaryOrange" icon={<InfoIcon />} />
        <span>
          <Trans i18nKey="VehicleQuantityInfo.message" count={maximum}>
            Vous souhaitez commander plus de 7 AMIs ? Vous êtes un organisme
            public ? Pour toute demande spécifique,{" "}
            <Link
              className="text-primaryOrange underline cursor-pointer hover:text-primaryDark"
              onClick={handleLinkClick}
            >
              Cliquer ici
            </Link>
          </Trans>
        </span>
      </div>
      <VehicleQuantityInfoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

VehicleQuantityInfo.propTypes = {
  maximum: number.isRequired,
};

export default VehicleQuantityInfo;
